import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import '@/App.css';
import '@/index.css';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import PendingApproval from './pages/PendingApproval';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Account from './pages/Account';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminOrdersOnly from './pages/admin/AdminOrdersOnly';
import SuperAdminLogin from './pages/admin/SuperAdminLogin';
import { TermsPage, PrivacyPage, ShippingPage, ReturnPage, ContactPage } from './pages/InfoPages';
import CartPreviewSheet from './components/CartPreviewSheet';
import MediaProtection from './components/MediaProtection';

import { DistributorAuthProvider, AdminAuthProvider, SuperAdminAuthProvider } from './lib/auth';
import { CartProvider } from './lib/cart';
import { RequireAnyAuth, RequireAdmin, RequireSuperAdmin } from './components/ProtectedRoute';

function App() {
    return (
        <BrowserRouter>
            <SuperAdminAuthProvider>
                <AdminAuthProvider>
                    <DistributorAuthProvider>
                        <CartProvider>
                            <ScrollToTop />
                            <MediaProtection />
                            <Routes>
                                {/* Public homepage — any authed realm (distributor / employee / super admin). */}
                                <Route path="/" element={<RequireAnyAuth><Home /></RequireAnyAuth>} />
                                <Route path="/cart" element={<RequireAnyAuth><Cart /></RequireAnyAuth>} />
                                <Route path="/checkout" element={<RequireAnyAuth><Checkout /></RequireAnyAuth>} />
                                <Route path="/account" element={<RequireAnyAuth><Account /></RequireAnyAuth>} />
                                <Route path="/orders" element={<RequireAnyAuth><Orders /></RequireAnyAuth>} />
                                <Route path="/orders/:id" element={<RequireAnyAuth><OrderDetail /></RequireAnyAuth>} />

                                {/* Public info pages (Footer links) */}
                                <Route path="/terms" element={<RequireAnyAuth><TermsPage /></RequireAnyAuth>} />
                                <Route path="/privacy" element={<RequireAnyAuth><PrivacyPage /></RequireAnyAuth>} />
                                <Route path="/shipping" element={<RequireAnyAuth><ShippingPage /></RequireAnyAuth>} />
                                <Route path="/returns" element={<RequireAnyAuth><ReturnPage /></RequireAnyAuth>} />
                                <Route path="/contact" element={<RequireAnyAuth><ContactPage /></RequireAnyAuth>} />

                                {/* Distributor auth */}
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/pending-approval" element={<PendingApproval />} />

                                {/* Employee Admin login (email+password) */}
                                <Route path="/admin" element={<AdminLogin />} />
                                {/* Employee Admin → Check Orders (view-only) */}
                                <Route path="/admin/orders" element={<RequireAdmin><AdminOrdersOnly /></RequireAdmin>} />

                                {/* Super Admin — URL not linked anywhere */}
                                <Route path="/secure-admin-login" element={<SuperAdminLogin />} />
                                <Route path="/secure-admin-dashboard" element={<RequireSuperAdmin><AdminDashboard mode="super_admin" /></RequireSuperAdmin>} />

                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                            <CartPreviewSheet />
                        </CartProvider>
                    </DistributorAuthProvider>
                </AdminAuthProvider>
            </SuperAdminAuthProvider>
        </BrowserRouter>
    );
}

export default App;
